// Order Cut チェックアウトハンドラー
(function() {
  'use strict';

  // グローバルにhandleCheckout関数を公開
  window.handleCheckout = async function() {
    console.log('チェックアウトボタンがクリックされました');

    try {
      // HTML5バリデーションでメール必須が残っているケースを無効化
      (function disableHtmlValidation() {
        document.querySelectorAll('input, select, textarea').forEach(function(el) {
          if (el.hasAttribute('required')) el.removeAttribute('required');
          if (el.hasAttribute('pattern')) el.removeAttribute('pattern');
        });
        document.querySelectorAll('form').forEach(function(form) {
          form.setAttribute('novalidate', 'novalidate');
        });
      })();

      // メールアドレス・郵便番号の取得・バリデーションはIssue #12により削除されました
      // チェックアウト時にShopify標準の入力フォームを使用します
      const email = '';
      const zip = '';

      // カート情報を取得
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      console.log('カート情報:', cart);
      
      // レーザーカット商品を抽出
      const laserCutItems = cart.items.filter(item => 
        item.properties && item.properties._isOrderCut === 'true'
      );
      
      if (laserCutItems.length === 0) {
        alert('レーザーカット商品がカートに見つかりません');
        return;
      }
      
      // 合計金額を計算
      // まずlocalStorageから価格を取得を試みる
      let customPrice = 0;
      
      // localStorageから価格情報を取得
      const storedSubtotal = localStorage.getItem('_subtotal');
      const storedTotalWithTax = localStorage.getItem('_totalWithTax');
      
      if (storedSubtotal) {
        customPrice = parseFloat(storedSubtotal);
        console.log('localStorageから価格を取得:', customPrice);
      } else {
        // プロパティから価格を取得（フォールバック）
        laserCutItems.forEach(item => {
          const props = item.properties;
          if (props._customPrice) {
            customPrice += parseFloat(props._customPrice);
          } else if (props._subtotal) {
            customPrice += parseFloat(props._subtotal);
          }
        });
      }
      
      // 価格が0の場合はエラー
      if (customPrice === 0) {
        alert('価格情報が取得できません。ページを再読み込みしてください。');
        window.location.reload();
        return;
      }
      
      // 公開APIエンドポイントを使用（CORSが設定済み）
      const apiUrl = 'https://order-cut.onrender.com/api/draft-order';
      console.log('APIエンドポイント:', apiUrl);
      
      // 現在のShopifyストアドメインを取得
      let currentShop = window.Shopify?.shop;

      if (!currentShop) {
        const host = window.location.hostname;
        if (host.endsWith('.myshopify.com')) {
          currentShop = host;
        } else {
          // フォールバック: 環境変数等で埋め込まれた値があれば使用
          currentShop = window.ORDER_CUT_SHOP_DOMAIN || 'ansoken-app.myshopify.com';
        }
      }

      const requestData = {
        cart: cart,
        shop: currentShop,
        // email, // Issue #12: 削除
        // zip, // Issue #12: 削除
        laserCutItems: laserCutItems,
        customPrice: customPrice.toString(),
        timestamp: Date.now() // 新しいDraft Orderを強制作成
      };

      console.log('送信データ:', requestData);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Shop-Domain': currentShop
        },
        body: JSON.stringify(requestData)
      });
      
      console.log('APIレスポンスステータス:', response.status);
      
      if (!response.ok) {
        let errorText = '';
        try {
          errorText = await response.text();
        } catch (e) {
          errorText = 'エラーテキストの取得に失敗';
        }
        console.error('APIエラー:', errorText);
        throw new Error(`サーバーエラー: ${response.status} - ${errorText}`);
      }
      
      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error('JSONパースエラー:', jsonError);
        throw new Error('APIレスポンスの解析に失敗しました。レスポンスがJSON形式ではありません。');
      }
      
      console.log('APIレスポンス:', data);
      console.log('invoiceUrl:', data.invoiceUrl);
      console.log('invoice_url:', data.invoice_url);
      console.log('draftOrderId:', data.draftOrderId);
      
      // サーバー側のレスポンス形式に合わせてドラフトオーダーIDを取得
      const draftOrderId = data.draftOrderId || (data.draft_order && data.draft_order.id);

      if (draftOrderId) {
        // Draft Orderが作成されたら、顧客用のインボイスページへリダイレクト
        // invoiceUrlがあればそれを使用、なければドラフトオーダーのインボイスURLを構築
        let checkoutUrl = data.invoiceUrl || data.invoice_url;
        
        if (!checkoutUrl) {
          console.warn('インボイスURLが返されていません。ドラフトオーダーIDから構築します。');
          // インボイスURLが返されていない場合は、ドラフトオーダーIDから構築
          // 注: これは顧客用のURLであり、管理画面のURLではありません
          checkoutUrl = `/draft_orders/${draftOrderId}/invoice`;
        }
        
        console.log('チェックアウトURLへリダイレクト:', checkoutUrl);
        console.log('リダイレクト処理を開始します...');
        
        // 絶対URLか相対URLかを判定
        if (checkoutUrl.startsWith('http')) {
          // 絶対URLの場合はそのまま使用
          console.log('絶対URLでリダイレクト:', checkoutUrl);
          window.location.href = checkoutUrl;
        } else {
          // 相対URLの場合は現在のドメインに追加
          const fullUrl = `https://ansoken-app.myshopify.com${checkoutUrl}`;
          console.log('相対URLを絶対URLに変換してリダイレクト:', fullUrl);
          window.location.href = fullUrl;
        }
      } else {
        throw new Error('Draft Orderの作成に失敗しました');
      }
      
    } catch (error) {
      console.error('チェックアウトエラー:', error);
      console.error('エラースタック:', error.stack);
      console.error('エラーメッセージ:', error.message);
      alert('チェックアウト処理中にエラーが発生しました。\n' + error.message);
    }
  };
  
  // ページ読み込み時に自動的にチェックアウトボタンにイベントリスナーを追加
  document.addEventListener('DOMContentLoaded', function() {
    const checkoutBtn = document.querySelector('.checkout-button, #checkoutBtn, [onclick*="handleCheckout"]');
    if (checkoutBtn && !checkoutBtn.onclick) {
      checkoutBtn.addEventListener('click', window.handleCheckout);
      console.log('チェックアウトボタンにイベントリスナーを追加しました');
    }
  });
  
})();
